import React from 'react';
import { Logo } from 'components/shared/NavigationBar/components/Logo';
import styles from './AuditNavigationBar.module.scss';

export const AuditNavigationBar = () => {

  return (
    <header className={styles.container}>
      <Logo className={styles.logo} isNira />
    </header>
  );
};
